import { render, staticRenderFns } from "./VerificationDetails.vue?vue&type=template&id=7739a316&scoped=true"
import script from "./VerificationDetails.vue?vue&type=script&lang=js"
export * from "./VerificationDetails.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./VerificationDetails.vue?vue&type=style&index=2&id=7739a316&prod&lang=css"
import style3 from "./VerificationDetails.vue?vue&type=style&index=3&id=7739a316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7739a316",
  null
  
)

export default component.exports